import { render, staticRenderFns } from "./otherAdd.vue?vue&type=template&id=05e42eda&scoped=true&"
import script from "./otherAdd.vue?vue&type=script&lang=js&"
export * from "./otherAdd.vue?vue&type=script&lang=js&"
import style0 from "./otherAdd.vue?vue&type=style&index=0&id=05e42eda&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e42eda",
  null
  
)

export default component.exports